import React from "react";
import  ReactDOM  from "react-dom";

function Nav(){
    return(
        <nav id=""class="navbar" >
           <ul>
           <li><a href="#">Home</a></li>
           <li><a href="#myprojects">Projects</a></li>
           <li><a href="#myskills">Skills</a></li>
           <li><a href="#myContact">Contact Me</a></li>
           </ul>
       
      
</nav>
    );

   

}
export default Nav;